import { Cog, Ruler, Layers, Lightbulb, Anvil, Feather, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
    { id: "fresatura-cnc", icon: Cog, title: "Fresatura CNC", text: "Lavorazioni di fresatura CNC a 3 assi per la realizzazione di componenti e particolari meccanici." },
    { id: "pezzi-su-misura", icon: Ruler, title: "Pezzi su misura", text: "Realizzazione di componenti e pezzi secondo specifiche, misure e necessità del cliente." },
    { id: "stampi", icon: Layers, title: "Stampi", text: "Realizzazione di stampi e componenti destinati a diverse esigenze produttive." },
    { id: "prototipi", icon: Lightbulb, title: "Prototipi", text: "Realizzazione di prototipi e particolari per sviluppare e verificare nuove soluzioni." },
    { id: "ferro", icon: Anvil, title: "Ferro", text: "Lavorazioni e realizzazione di componenti in ferro." },
    { id: "alluminio", icon: Feather, title: "Alluminio", text: "Lavorazioni e realizzazione di componenti in alluminio." },
];

const ServiceCard = ({ id, icon: Icon, title, text, index }) => (
    <article
        data-testid={`service-card-${id}`}
        className="group relative h-full bg-tl-dark2 p-8 transition-colors duration-300 hover:bg-tl-card"
    >
        <span className="font-mono-tl text-xs text-white/30">0{index + 1}</span>
        <Icon size={30} strokeWidth={1.5} className="mt-6 text-tl-orange" />
        <h3 className="mt-5 font-display text-xl font-semibold tracking-normal text-white">{title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-tl-mutedLight">{text}</p>
        <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-tl-orange transition-[width] duration-500 group-hover:w-full" />
    </article>
);

const SectionHead = () => (
    <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div>
            <Reveal>
                <Eyebrow number="02" label="Lavorazioni" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                    Le nostre lavorazioni<span className="text-tl-orange">.</span>
                </h2>
            </Reveal>
        </div>
        <Reveal delay={0.15}>
            <button
                type="button"
                data-testid="lavorazioni-cta"
                onClick={() => scrollToId("contatti")}
                className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-mono-tl text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-tl-orange hover:text-tl-orange"
            >
                Parlaci del tuo progetto
                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </button>
        </Reveal>
    </div>
);

export default function Lavorazioni() {
    return (
        <section id="lavorazioni" data-testid="lavorazioni-section" className="bg-tl-dark2 py-20 md:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <SectionHead />
                <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.id} delay={0.06 * i} y={24}>
                            <ServiceCard {...s} index={i} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
